import { render } from "./AddChartToReportTheme.vue?vue&type=template&id=5a8b47f4"
import script from "./AddChartToReportTheme.vue?vue&type=script&lang=js"
export * from "./AddChartToReportTheme.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__